import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
// ;
import config from '../../../config';
//import funciones from '../../middleware/funciones';
//import { Header } from 'react-bootstrap/lib/Modal';

class Retenciones extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        super(props);
        this.state = {
            data: [],
            empresa: currentCompany,
            tipo: currentUserType
        };
    }
    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/withholdings/', datasend).then(response => response.json())
            .then(data => this.setState({ data }));
    }

    render() {
        const dato = (this.state.data) ? this.state.data : [];

        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };

        return (

            <div className="contenedor">

                <Jumbotron style={style}>
                    <h1>Modulo Retenciones</h1>
                </Jumbotron>
                <Button className="plus" size="sm" href="/retenciones/crear/" variant="outline-primary">Crear Retencion</Button>
                <Table hover bordered responsive size="sm" className="table">
                    <thead>
                        <tr>
                            <th>EMPRESA</th>
                            <th>TIPO</th>
                            <th>DESCRIPCION</th>
                            <th>PORCENTAJE</th>
                            <th>BASE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dato.map(function (currentData, index) {
                            return <tr key={index + "d0"}>
                                <td key={index + "d1"}>{currentData.ID_EMPRESA}</td>
                                <td key={index + "d2"}>{currentData.TIPO_RETENCION}</td>
                                <td key={index + "d3"}>{currentData.DESCRIPCION_RETENCION}</td>
                                <td key={index + "d4"}>{currentData.PORCENTAJE_RETENCION}</td>
                                <td key={index + "d5"}>{currentData.BASE_MINIMA_VENTA}</td>
                                <td key={index + "d6"}><Button size="sm" href={"/retenciones/crear/?" + currentData.ID_RETENCIONES} variant="outline-primary">Editar</Button></td>
                            </tr>;
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}
export default (Retenciones);


// WEBPACK FOOTER //
// ./src/components/bussines/catalogos/retenciones.jsx